import decodeLittleEndian from './decodeLittleEndian.js';
import { trimToNativeFrame } from './nativeFrameBytes.js';
async function decodeEncapsulatedUncompressed(imageFrame, pixelData) {
    return decodeLittleEndian(imageFrame, trimToNativeFrame(imageFrame, pixelData, 'decodeEncapsulatedUncompressed'));
}
export default decodeEncapsulatedUncompressed;
